import React, { Component } from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import * as Common from 'common/components';
import { isLockedFile } from 'lib/pdfs/autosur/valeResguardoAutosur';
import { voucherStatus } from 'lib/vouchers/custodian';

class AssetDetailFiles extends Component {
  // A signed voucher: current (signed for today's custodian) or previous, who it
  // was signed for and when (lib/vouchers/custodian).
  renderVoucher = (file) => {
    const { t, asset } = this.props;
    const current = voucherStatus(file, asset) === 'current';
    return (
      <span>
        <span className="badge badge-secondary ml-2">
          <i className="fa fa-lock mr-1" />
          {t('files.locked')}
        </span>
        <span className={current ? 'badge badge-success ml-1' : 'badge badge-light border ml-1'}>
          {t(current ? 'files.voucherCurrent' : 'files.voucherPrevious')}
        </span>
        <small className="d-block text-muted">
          {t('files.signedFor')}: {file.custodianName || t('files.custodianUnknown')}
          {file.signedAt
            ? ` · ${t('files.signedAt')} ${moment(file.signedAt).format('DD/MM/YYYY HH:mm')}`
            : ''}
        </small>
      </span>
    );
  };

  render = () => {
    const files =
      (this.props.asset._files && this.props.asset._files.filter((file) => !file.deleted)) || [];
    return (
      <Form.Section title={this.props.t('assets.section.files')}>
        <table className="table table-hover table-striped table-sm">
          <thead>
            <tr>
              <th width="20%" className="text-center">
                {this.props.t('files.preview')}
              </th>
              <th width="80%">{this.props.t('files.name')}</th>
            </tr>
          </thead>
          <tbody>
            {this.props.asset._files.length === 0 && (
              <tr>
                <td colSpan="4">
                  <div className="alert alert-info text-center mb-0">
                    <i className="fa fa-lg fa-info-circle pr-3" />
                    {this.props.t('files.empty')}
                  </div>
                </td>
              </tr>
            )}
            {files.map((file) => (
              <tr key={file.id}>
                <td className="text-center align-middle">
                  <Common.File file={file} />
                </td>
                <td className="align-middle">
                  {file.name}
                  {isLockedFile(file) && this.renderVoucher(file)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Form.Section>
    );
  };
}

export default translate()(AssetDetailFiles);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailFiles.js